import { getRootUrl } from '@bingads-webui-react/copilot-utils';
import { getBotMtApiUrl } from './utils/xandr-bot-mt';
import type { ConversationRequestContext, RequestHeaders } from './types';

export type IDeleteConversationProps = ConversationRequestContext;

function deleteConversationUrl({
  cid,
  uid,
  conversationId,
  productName,
}: IDeleteConversationProps) {
  if (productName === 'xandr_curate' || productName === 'xandr_monetization') {
    // need to bypass /tokenexchange for xandr products, default to token exchange for all others
    return `${getBotMtApiUrl()}/chathistory?userId=${encodeURIComponent(uid)}&customerId=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}`;
  }
  return `${getRootUrl()}/tokenexchange/chatdelete?uid=${encodeURIComponent(uid)}&cid=${encodeURIComponent(cid)}&conversationId=${encodeURIComponent(conversationId)}`;
}

export function deleteConversation({
  cid,
  uid,
  conversationId,
  productName,
  authToken,
}: IDeleteConversationProps) {
  const url = deleteConversationUrl({
    cid, uid, conversationId, productName,
  });
  const isXandrProduct = productName === 'xandr_curate' || productName === 'xandr_monetization';
  const method = isXandrProduct ? 'DELETE' : 'POST';
  const headers: RequestHeaders = {
    'Content-Type': 'application/json',
    'x-requested-with': 'XMLHttpRequest',
  };
  if (isXandrProduct && authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  return window.fetch(url, {
    method,
    headers,
    credentials: isXandrProduct ? 'omit' : 'include',
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error(await response.text());
      }
      return {
        data: { success: true },
        hasError: false,
      };
    })
    .catch(error => ({
      hasError: true,
      message: 'Failed to delete conversation',
      error: error?.message,
    }));
}
